var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"100px"}},[_c('button',{on:{"click":_vm.getLocation}},[_vm._v("获取")]),_c('span',[_vm._v(_vm._s(_vm.location))])])}
var staticRenderFns = []

export { render, staticRenderFns }